var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "sidenav-container",
        { "dark-blue-mode": _vm.$route.meta.headerColor === "dark" }
      ],
      attrs: { id: "sideMenu" }
    },
    [
      !_vm.$route.path.includes("/gop/")
        ? _c(
            "TransitionGroup",
            {
              attrs: {
                name:
                  _vm.$store.getters.getSideMenuField("currentSlide") ===
                  _vm.slideSteps.first
                    ? "slideInverce"
                    : "slide"
              }
            },
            [
              _vm.$store.getters.getSideMenuField("currentSlide") ===
              _vm.slideSteps.first
                ? _c("SlideFirst", { key: "one" })
                : _vm._e()
            ],
            1
          )
        : _c("GopSideMenu")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }